export const filterTypes = {
  INPUT: 'input_filter',
  DROPDOWN: 'dropdown_filter',
};

export const types = {
  REINIT_FILTERS: 'REINIT_FILTERS',
  UPDATE_FILTER: 'UPDATE_FILTER',
};
